export default __webpack_public_path__ + "static/media/icon-amex.14c5f38a4559ecd4a9486d78fd3f4e27.svg";